import { render, staticRenderFns } from "./NavbarSshi2023.vue?vue&type=template&id=643fec34&scoped=true"
import script from "./NavbarSshi2023.vue?vue&type=script&lang=js"
export * from "./NavbarSshi2023.vue?vue&type=script&lang=js"
import style0 from "./NavbarSshi2023.vue?vue&type=style&index=0&id=643fec34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "643fec34",
  null
  
)

export default component.exports